export default __webpack_public_path__ + "static/media/footer-gallery-5.210af3f1.jpg";